import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdTableRows, MdCode } from 'react-icons/md';
import Layout from '../components/Layout';
import OptionCard from '../components/OptionCard';
import { User } from '../data/mockData';
import './MeasurementCreationOptionsPage.css';

const MeasurementCreationOptionsPage: React.FC = () => {
  const [user, setUser] = useState<User | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const handleEOCReportClick = () => {
    navigate('/create-measurement-eoc');
  };

  const handleTagCollectionClick = () => {
    navigate('/create-measurement-tag');
  };

  if (!user) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <Layout user={user}>
      <div className="measurement-creation-options-page">
        <h1>Create Measurement</h1>
        <p className="options-subtitle">Choose how you want to create your measurement</p>
        
        <div className="options-grid">
          <OptionCard
            headline="Create via EOC report"
            text="Upload an End of Campaign report to automatically extract measurement data and generate brand insights."
            buttonText="Create"
            icon={MdTableRows as React.ElementType}
            onButtonClick={handleEOCReportClick}
          />
          
          <OptionCard
            headline="Create via Tag collection"
            text="Set up measurement tracking using tags. Collect data over time and analyze campaign performance."
            buttonText="Create"
            icon={MdCode as React.ElementType}
            onButtonClick={handleTagCollectionClick}
          />
        </div>
      </div>
    </Layout>
  );
};

export default MeasurementCreationOptionsPage;
